import './App.css';
import { useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Portfolio from './pages/portfolio';
import NotFound from './pages/not-found';

function App() {
  const originalTitle = useRef(document.title);
  
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
        document.title = "Hey, come back! 👋";
      } else {
        document.title = originalTitle.current;
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      document.title = originalTitle.current; 
    };
  }, []);

  useEffect(() => {
    console.log("%cHey there, code explorer! 👋", "color: #00bfff; font-size: 1.2em; font-weight: bold;");
    console.log("Looks like you're checking out the console. Nice!");
    console.log("This portfolio was built with React, TypeScript, and lots of coffee ☕.");
    console.log("Looking for a passionate developer? Let's connect: https://www.linkedin.com/in/carles-falc%C3%B3-riera-942758172/");
  }, []);

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Portfolio />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;